import { Component } from "react";
import { withRouter } from '../../common/with-router';
import { Card, Form, Button, Row, Col, Table, Modal, Badge, Alert } from "react-bootstrap";
import { FaPlus, FaSearch, FaEraser, FaRegEdit, FaTrash, FaSpinner, FaCheck, FaListUl } from "react-icons/fa";
import api from "../../services/api";
import { getCurrentUser, formataDataExibicao, formataDataHoraExibicao } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import AsyncSelect from 'react-select/async';

const voucherVazio = { id: null, codigo: '', descricao: '', limite_uso: '', data_limite: '', programa_id: '', programa_nome: '' };

class Vouchers extends Component {
    constructor(props) {
        super(props);

        const user = getCurrentUser() || {};
        this.isSuperUser = user.is_superuser === true || user.tipo_usuario === '';
        this.isGestor = user.tipo_usuario === 'gestor';
        // admin (superuser) e gestor podem excluir; navegadora/operadora não
        this.podeExcluir = this.isSuperUser || this.isGestor;
        this.ambiente_programa_id = user.ambiente_programa_id || '';

        this.state = {
            // filtros
            filtroCodigo: '',
            filtroProgramaId: '',
            filtroProgramaNome: '',
            // listagem paginada
            listRegistros: {},
            page_numb: 1,
            loading: false,
            error: '',
            // modal cadastro/edição
            showModal: false,
            loadingModal: false,
            modalTitulo: 'Cadastrar Voucher',
            voucherEdit: { ...voucherVazio },
            // modal de logs de uso
            showLogs: false,
            loadingLogs: false,
            logsVoucher: null,
            logsUtilizacoes: [],
        };

        this.carregaProgramasDelay = this.delayCamposAsync(this.carregarProgramas.bind(this), 800);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaVoucher = this.buscaVoucher.bind(this);
    }

    componentDidMount() {
        this.consultaVouchers(1);
    }

    delayCamposAsync = (fn, delay = 800) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            return new Promise((resolve) => {
                timeout = setTimeout(async () => {
                    try { resolve(await fn(...args)); } catch (e) { resolve([]); }
                }, delay);
            });
        };
    };

    // ---------- Listagem ----------
    consultaVouchers = (page_numb = 1) => {
        this.setState({ loading: true, error: '' });

        let filtros = `?page=${page_numb}`;
        if (this.state.filtroCodigo) filtros += `&codigo=${encodeURIComponent(this.state.filtroCodigo)}`;
        // Escopo por programa: superuser filtra opcionalmente; gestor/navegadora enviam o programa
        // do ambiente (o backend também reforça isso via X-Programa-ID).
        if (this.isSuperUser) {
            if (this.state.filtroProgramaId) filtros += `&programa_id=${this.state.filtroProgramaId}`;
        } else if (this.ambiente_programa_id) {
            filtros += `&programa_id=${this.ambiente_programa_id}`;
        }

        api.get(`/vouchers/${filtros}`)
            .then(response => {
                this.setState({ listRegistros: response.data, page_numb, loading: false });
            })
            .catch(error => {
                console.error('Erro ao carregar vouchers:', error);
                let msg = 'Erro ao carregar os vouchers, tente novamente';
                if (error.response && error.response.status === 500) msg = 'Servidor indisponível no momento, tente novamente';
                if (error.response && error.response.status === 403) msg = 'Você não tem permissão para acessar esta área.';
                this.setState({ error: msg, loading: false });
            });
    };

    onClickPagina(num_page) {
        this.setState({ loading: true, page_numb: num_page });
        this.consultaVouchers(num_page);
    }

    buscaVoucher(e) {
        e.preventDefault();
        this.consultaVouchers(1);
    }

    limpaFiltro = () => {
        this.setState({ filtroCodigo: '', filtroProgramaId: '', filtroProgramaNome: '' }, () => this.consultaVouchers(1));
    };

    handleChangeFiltros = (event, fieldName) => {
        if (fieldName === 'programa_id') {
            this.setState({
                filtroProgramaId: event ? event.value : '',
                filtroProgramaNome: event ? event.label : '',
            });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    carregarProgramas = async (inputValue = "") => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            return (response.data.results || []).map(p => ({ value: p.id, label: p.nome }));
        } catch (error) {
            console.error("Erro ao carregar programas:", error);
            return [];
        }
    };

    // ---------- Modal Cadastro/Edição ----------
    abrirModalNovo = () => {
        this.setState({ showModal: true, modalTitulo: 'Cadastrar Voucher', voucherEdit: { ...voucherVazio } });
    };

    abrirModalEditar = (voucher) => {
        this.setState({
            showModal: true,
            modalTitulo: 'Editar Voucher',
            voucherEdit: {
                id: voucher.id,
                codigo: voucher.codigo ?? '',
                descricao: voucher.descricao ?? '',
                limite_uso: voucher.limite_uso ?? '',
                data_limite: voucher.data_limite ?? '',
                programa_id: voucher.programa_id ?? '',
                programa_nome: voucher.programa_nome ?? '',
            },
        });
    };

    fecharModal = () => this.setState({ showModal: false });

    handleChangeModal = (event) => {
        const { name, value } = event.target;
        this.setState(prevState => ({ voucherEdit: { ...prevState.voucherEdit, [name]: value } }));
    };

    handleChangeProgramaModal = (event) => {
        this.setState(prevState => ({
            voucherEdit: {
                ...prevState.voucherEdit,
                programa_id: event ? event.value : '',
                programa_nome: event ? event.label : '',
            },
        }));
    };

    salvarVoucher = async () => {
        const voucher = this.state.voucherEdit;

        // superuser precisa escolher o programa ao cadastrar; nos demais o backend força o do ambiente
        if (!voucher.id && this.isSuperUser && !voucher.programa_id) {
            withReactContent(Swal).fire({ icon: 'error', showCloseButton: true, title: 'Atenção', text: 'Selecione o programa do voucher.' });
            return;
        }

        const url = voucher.id ? `/vouchers/${voucher.id}/` : '/vouchers/';
        const metodo = voucher.id ? 'put' : 'post';

        const dadosVoucher = {
            status: true,
            codigo: voucher.codigo,
            descricao: voucher.descricao,
            limite_uso: voucher.limite_uso !== '' ? voucher.limite_uso : null,
            data_limite: voucher.data_limite || null,
        };
        // no cadastro, envia o programa: superuser escolhe; demais mandam o ambiente (o backend
        // reforça o do ambiente para não-superuser). Na edição, o programa não muda.
        if (!voucher.id) {
            dadosVoucher.programa_id = this.isSuperUser ? voucher.programa_id : this.ambiente_programa_id;
        }

        this.setState({ loadingModal: true });
        try {
            await api({ method: metodo, url, data: dadosVoucher });
            withReactContent(Swal).fire({
                title: <p>{voucher.id ? 'Voucher atualizado com sucesso' : 'Voucher cadastrado com sucesso'}</p>,
                icon: 'success',
                showCloseButton: true,
            });
            this.setState({ showModal: false });
            this.consultaVouchers(this.state.page_numb);
        } catch (error) {
            let erro_msg = 'Erro ao salvar o voucher, verifique os campos e tente novamente';
            let content = '';
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 403) {
                erro_msg = 'Você não tem permissão para esta ação.';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data || {};
                const rotulos = { codigo: 'Código', descricao: 'Descrição', limite_uso: 'Limite de uso', data_limite: 'Data limite', programa_id: 'Programa' };
                for (let key in campos) {
                    if (rotulos[key]) content += `<br>&bull; ${rotulos[key]}: ${campos[key]}`;
                }
            }
            withReactContent(Swal).fire({ icon: 'error', showCloseButton: true, title: <p>{erro_msg}</p>, html: content });
        } finally {
            this.setState({ loadingModal: false });
        }
    };

    // ---------- Exclusão (admin/gestor) ----------
    excluirVoucher = (voucher) => {
        const usado = (voucher.quantidade_usos || 0) > 0;
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: usado ? 'Inativar voucher?' : 'Excluir voucher?',
            html: usado
                ? `Este voucher já foi utilizado (${voucher.quantidade_usos} ${voucher.quantidade_usos === 1 ? 'uso' : 'usos'}). Para preservar o histórico, ele será <strong>inativado</strong> (não excluído). Deseja continuar?`
                : 'Deseja <strong>excluir definitivamente</strong> este voucher? Esta ação não pode ser desfeita.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: usado ? 'Sim, inativar' : 'Sim, excluir',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (!result.isConfirmed) return;

            api.delete(`/vouchers/${voucher.id}/`)
                .then((response) => {
                    const detail = (response.data && response.data.detail) || 'Voucher removido com sucesso.';
                    withReactContent(Swal).fire({ title: <p>{detail}</p>, icon: 'success', showCloseButton: true });
                    this.consultaVouchers(this.state.page_numb);
                })
                .catch(error => {
                    let erro_msg = 'Erro ao excluir o voucher, tente novamente';
                    if (error.response && error.response.status === 500) erro_msg = 'Servidor indisponível no momento';
                    if (error.response && error.response.status === 403) erro_msg = 'Você não tem permissão para excluir vouchers.';
                    withReactContent(Swal).fire({ icon: 'error', showCloseButton: true, title: <p>{erro_msg}</p> });
                });
        });
    };

    // ---------- Modal de Logs ----------
    abrirLogs = async (voucher) => {
        this.setState({ showLogs: true, loadingLogs: true, logsVoucher: voucher, logsUtilizacoes: [] });
        try {
            const response = await api.get(`/vouchers/${voucher.id}/`);
            this.setState({ logsUtilizacoes: response.data.dados_utilizacoes || [] });
        } catch (error) {
            console.error('Erro ao carregar logs do voucher:', error);
        } finally {
            this.setState({ loadingLogs: false });
        }
    };

    fecharLogs = () => this.setState({ showLogs: false, logsVoucher: null, logsUtilizacoes: [] });

    // ---------- Render ----------
    renderLinhas = () => {
        const results = this.state.listRegistros.results || [];
        if (results.length === 0) {
            return <tr><td colSpan={this.isSuperUser ? 8 : 7} style={{ textAlign: 'center' }}>Nenhum voucher encontrado</td></tr>;
        }

        return results.map((v) => {
            const voucher = {
                id: v.id,
                codigo: v.codigo ?? '',
                descricao: v.descricao ?? '',
                limite_uso: v.limite_uso ?? '',
                data_limite: v.data_limite ?? '',
                status: v.status,
                quantidade_usos: v.quantidade_usos ?? 0,
                programa_id: v.programa_id ?? v.dados_programa?.id ?? '',
                programa_nome: v.dados_programa?.nome ?? '',
            };
            return (
                <tr key={voucher.id}>
                    <td><span className="badge bg-success" style={{ fontSize: '0.9rem', letterSpacing: '1px' }}>{voucher.codigo}</span></td>
                    {this.isSuperUser && <td>{voucher.programa_nome || '-'}</td>}
                    <td>{voucher.descricao || '-'}</td>
                    <td>{voucher.limite_uso !== '' && voucher.limite_uso !== null ? voucher.limite_uso : 'Ilimitado'}</td>
                    <td>
                        <Button variant="light" size="sm" onClick={() => this.abrirLogs(voucher)}>
                            <FaListUl className="me-1" /> {voucher.quantidade_usos} {voucher.quantidade_usos === 1 ? 'uso' : 'usos'}
                        </Button>
                    </td>
                    <td>{voucher.data_limite ? formataDataExibicao(voucher.data_limite) : 'Sem limite'}</td>
                    <td><Badge bg={voucher.status ? 'success' : 'secondary'}>{voucher.status ? 'Ativo' : 'Inativo'}</Badge></td>
                    <td>
                        <Button variant="light" size="sm" className="me-1" onClick={() => this.abrirModalEditar(voucher)}>
                            <FaRegEdit /> Editar
                        </Button>
                        {this.podeExcluir && (
                            <Button variant="outline-danger" size="sm" onClick={() => this.excluirVoucher(voucher)}>
                                <FaTrash className="me-1" /> Excluir
                            </Button>
                        )}
                    </td>
                </tr>
            );
        });
    };

    render() {
        const { loading, error, listRegistros, page_numb, loadingModal, showModal, modalTitulo, voucherEdit,
                showLogs, loadingLogs, logsVoucher, logsUtilizacoes } = this.state;
        const colSpan = this.isSuperUser ? 8 : 7;

        return (
            <div>
                {/* Cabeçalho + botão */}
                <Row className="align-items-center">
                    <Col sm={6} lg={6}><h4 className="page-title">Vouchers</h4></Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" className="mb-3" size="sm" onClick={this.abrirModalNovo}>
                            <FaPlus /> Cadastrar Voucher
                        </Button>
                    </Col>
                </Row>

                {/* Filtros */}
                <Card className="cardDestaque">
                    <Card.Body>
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.buscaVoucher}>
                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Código do voucher</Form.Label>
                                        <Form.Control type="text" name="filtroCodigo" placeholder="Buscar por código"
                                            value={this.state.filtroCodigo} onChange={this.handleChangeFiltros} />
                                    </Form.Group>
                                </Col>
                                {this.isSuperUser && (
                                    <Col sm={4} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Programa</Form.Label>
                                            <AsyncSelect
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={this.carregaProgramasDelay}
                                                placeholder="Todos os programas"
                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                value={this.state.filtroProgramaId ? { value: this.state.filtroProgramaId, label: this.state.filtroProgramaNome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}
                            </Row>
                            <Button type="submit" variant="success" size="sm"><FaSearch className="me-2" /> Filtrar</Button>
                            <Button type="button" size="sm" variant="light" className="ms-2" onClick={this.limpaFiltro}>
                                <FaEraser /> Limpar filtro
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>

                {/* Tabela + paginação */}
                <Card className="cardDestaque">
                    <Card.Body className="pt-0">
                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    {this.isSuperUser && <th>Programa</th>}
                                    <th>Descrição</th>
                                    <th>Limite de uso</th>
                                    <th>Usos</th>
                                    <th>Data limite</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading
                                    ? <tr><td colSpan={colSpan} style={{ textAlign: 'center' }}><FaSpinner className="spinner-rotate" /> Buscando dados...</td></tr>
                                    : error
                                        ? <tr><td colSpan={colSpan} style={{ textAlign: 'center' }}>{error}</td></tr>
                                        : this.renderLinhas()}
                            </tbody>
                        </Table>
                        {'results' in listRegistros && listRegistros.results.length > 0 &&
                            <Paginacao dados={listRegistros} loading={loading} page_numb={page_numb} _onClickPagina={this.onClickPagina} />}
                    </Card.Body>
                </Card>

                {/* Modal Cadastro/Edição */}
                <Modal show={showModal} onHide={this.fecharModal} size="lg" backdrop="static">
                    <Modal.Header closeButton><Modal.Title>{modalTitulo}</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                {/* Programa: só no cadastro do superuser (gestor/navegadora usam o do ambiente) */}
                                {!voucherEdit.id && this.isSuperUser && (
                                    <Col sm={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Programa <span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={this.carregaProgramasDelay}
                                                placeholder="Selecione o programa"
                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                onChange={this.handleChangeProgramaModal}
                                                value={voucherEdit.programa_id ? { value: voucherEdit.programa_id, label: voucherEdit.programa_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Código</Form.Label>
                                        <Form.Control type="text" name="codigo" maxLength={50}
                                            placeholder="Deixe em branco para gerar automaticamente"
                                            value={voucherEdit.codigo} onChange={this.handleChangeModal} />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Limite de uso</Form.Label>
                                        <Form.Control type="number" min={1} name="limite_uso" placeholder="Ilimitado"
                                            value={voucherEdit.limite_uso} onChange={this.handleChangeModal} />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data limite</Form.Label>
                                        <Form.Control type="date" name="data_limite"
                                            value={voucherEdit.data_limite || ''} onChange={this.handleChangeModal} />
                                    </Form.Group>
                                </Col>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control as="textarea" rows={3} name="descricao"
                                            value={voucherEdit.descricao} onChange={this.handleChangeModal} />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>Cancelar</Button>
                        <Button variant="success" onClick={this.salvarVoucher} disabled={loadingModal}>
                            {loadingModal ? <><FaSpinner className="spinner-rotate me-1" /> Salvando...</> : <><FaCheck className="me-1" /> Salvar</>}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Logs de Uso */}
                <Modal show={showLogs} onHide={this.fecharLogs} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Logs de uso {logsVoucher ? `— ${logsVoucher.codigo}` : ''}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {loadingLogs ? (
                            <div style={{ textAlign: 'center' }}><FaSpinner className="spinner-rotate" /> Carregando...</div>
                        ) : logsUtilizacoes.length === 0 ? (
                            <Alert variant="light" className="mb-0">Nenhum uso registrado para este voucher.</Alert>
                        ) : (
                            <Table responsive size="sm" className="custom-table mb-0">
                                <thead>
                                    <tr><th>Atendimento</th><th>Paciente</th><th>Data de utilização</th></tr>
                                </thead>
                                <tbody>
                                    {logsUtilizacoes.map((u, idx) => (
                                        <tr key={u.id ?? idx}>
                                            <td>{u.atendimento_id ? `#${u.atendimento_id}` : '-'}</td>
                                            <td>{u.beneficiario_nome || '-'}</td>
                                            <td>{u.data_utilizacao ? formataDataHoraExibicao(u.data_utilizacao) : '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharLogs}>Fechar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Vouchers);
